import pickListMapping from '@/configs/pickListMapping';

export const mappingKey = (key, val) => {
  if(!val) return val;
  return pickListMapping?.[key]?.[val] || val;
};

// 去除多餘空白
export const oneline = (str) => str.replace(/(?:\n(?:\s*))+/g, ' ');
